import { render, staticRenderFns } from "./TextH2.vue?vue&type=template&id=d85f167c"
import script from "./TextH2.vue?vue&type=script&lang=js"
export * from "./TextH2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports